<div class="container content">
  <div class="center-element">
    <div class="col-md-12">
      <img src="/assets/logo-posso-agendar-borda-azul-desktop.svg" alt="Posso Agendar?" class="login-img hidden-xs" />
      <img src="/assets/logo-posso-agendar-borda-azul.svg" alt="Posso Agendar?" class="login-img visible-xs" />
      <h2>Olá, bem vindo a plataforma que cuida da sua saúde!</h2>
    </div>

    <p>Para completar seu cadastro, escolha seu <b>tipo de usuário</b>:</p>
    <div class="actions-type">
      <button mat-raised-button color="primary" (click)="completeRegistration('patient')">Paciente</button>
      <button mat-raised-button color="primary" (click)="completeRegistration('practitioner')">Especialista</button>
      <button mat-raised-button color="primary" (click)="completeRegistration('secretary')">Secretária</button>
      <button mat-raised-button color="primary" (click)="completeRegistration('organization')">Instituição</button>
    </div>
  </div>
</div>
